import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/layouts/default.vue").then(m => m.default || m)),
  "new-default": defineAsyncComponent(() => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/layouts/new-default.vue").then(m => m.default || m))
}